// extracted by css-extract-rspack-plugin
export default {"tabbedNav":"TabbedTimeline-module__tabbedNav__rAS36","stuck":"TabbedTimeline-module__stuck__dTkqo","sentinel":"TabbedTimeline-module__sentinel__E0Dg2"};